var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#7C7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20532 3.01782L9.22332 5.81401L8.84982 5.81682L8.83182 3.02063L9.20532 3.01782ZM11.8749 10.4259L14.2436 11.8249L14.0541 12.1466L11.6859 10.7477L11.8749 10.4259ZM6.13744 10.4259L6.32701 10.7477L3.95888 12.1466L3.76932 11.8249L6.13744 10.4259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1314 7.39966L8.99438 5.57153L5.85281 7.39235L8.99381 9.21372L12.1314 7.39966ZM8.99325 6.00353L11.3873 7.39853L8.99381 8.78228L6.59756 7.39291L8.99381 6.00353H8.99325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18056 8.89037L6.03787 7.06787L6.04237 10.7056L9.18112 12.5134V8.89037H9.18056ZM6.4125 7.71643L8.80762 9.10468V11.8671L6.41531 10.489L6.4125 7.71643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9464 10.7128V7.07568L8.80762 8.88975V12.5122L11.9464 10.7128ZM11.5723 7.72256V10.4957L9.18055 11.8682V9.10518L11.5723 7.72256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3353 5.90625L8.9955 2.8125L3.65625 5.90625V12.0938L8.9955 15.1875L14.3353 12.0938V5.90625ZM8.9955 3.24394L13.9618 6.12169V11.8783L8.9955 14.7555L4.02863 11.8777V6.12225L8.9955 3.24394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0636 5.85784C14.1033 5.83488 14.15 5.82729 14.1948 5.83651C14.2397 5.84574 14.2796 5.87114 14.307 5.90789C14.3344 5.94463 14.3473 5.99015 14.3433 6.03579C14.3393 6.08142 14.3186 6.124 14.2853 6.1554L14.2504 6.18128L8.9955 9.22103L3.7575 6.18071C3.71781 6.15777 3.68793 6.12103 3.67358 6.07748C3.65923 6.03393 3.6614 5.98662 3.67968 5.94457C3.69796 5.90252 3.73107 5.86867 3.77271 5.84946C3.81434 5.83025 3.86159 5.82702 3.90544 5.8404L3.94482 5.85784L8.99607 8.78846L14.0636 5.85784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99663 8.81836C9.08663 8.81836 9.16256 8.88248 9.17944 8.96742L9.18338 9.00511V14.9715C9.18326 15.0177 9.16605 15.0622 9.13506 15.0964C9.10407 15.1307 9.0615 15.1522 9.01557 15.1569C8.96964 15.1616 8.9236 15.1491 8.88634 15.1218C8.84908 15.0945 8.82324 15.0544 8.81381 15.0092L8.80988 14.9715V9.00567C8.80988 8.90273 8.89369 8.81892 8.99663 8.81892V8.81836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFida);
export default __webpack_public_path__ + "static/media/fida.cf423d9c59b75397e8cedc30d4788dcb.svg";
export { ForwardRef as ReactComponent };